import { render, staticRenderFns } from "./ArceDetails.vue?vue&type=template&id=74ae6568&"
import script from "./ArceDetails.vue?vue&type=script&lang=js&"
export * from "./ArceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports